import React from 'react'
import TableCarousel from '../../Components/table/TableCarousel'

const CarouselAdmin = () => {
  return <TableCarousel />
}

export default CarouselAdmin
